import CircularProgress from "@mui/material/CircularProgress";

const Loader = () => {
  return (
    <CircularProgress sx={{ color: "#1C485F" }}/>
  )
}

export default Loader